"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const _import$1 = require("./import-LK6z3Rbv.js");
const React = require("react");
const utilities_css = require("../utilities/css.js");
const omit = require("./omit-tcSejr4A.js");
const _import = require("./import-bQvoOT-e.js");
function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
  let {
    elementType = "button",
    isDisabled,
    onPress,
    onPressStart,
    onPressEnd,
    onPressUp,
    onPressChange,
    preventFocusOnPress,
    allowFocusWhenDisabled,
    // @ts-ignore
    onClick: deprecatedOnClick,
    href,
    target,
    rel,
    type = "button"
  } = props;
  let additionalProps;
  if (elementType === "button")
    additionalProps = {
      type,
      disabled: isDisabled
    };
  else
    additionalProps = {
      role: "button",
      tabIndex: isDisabled ? void 0 : 0,
      href: elementType === "a" && isDisabled ? void 0 : href,
      target: elementType === "a" ? target : void 0,
      type: elementType === "input" ? type : void 0,
      disabled: elementType === "input" ? isDisabled : void 0,
      "aria-disabled": !isDisabled || elementType === "input" ? void 0 : isDisabled,
      rel: elementType === "a" ? rel : void 0
    };
  let { pressProps, isPressed } = _import.$f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPress,
    onPressUp,
    isDisabled,
    preventFocusOnPress,
    ref
  });
  let { focusableProps } = _import.$e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, ref);
  if (allowFocusWhenDisabled)
    focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
  let buttonProps = _import$1.$3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, pressProps, _import$1.$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  }));
  return {
    isPressed,
    buttonProps: _import$1.$3ef42575df84b30b$export$9d1611c77c2fe928(additionalProps, buttonProps, {
      "aria-haspopup": props["aria-haspopup"],
      "aria-expanded": props["aria-expanded"],
      "aria-controls": props["aria-controls"],
      "aria-pressed": props["aria-pressed"],
      onClick: (e) => {
        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn("onClick is deprecated, please use onPress");
        }
      }
    })
  };
}
function logWarningIfInvalidColorVariantCombination(color, variant) {
  var _a;
  const validColorVariantCombinations = {
    filled: ["primary", "secondary", "success", "warning", "neutral"],
    outlined: ["primary", "secondary", "support", "inverse"],
    link: ["primary", "secondary"]
  };
  if (!((_a = validColorVariantCombinations[variant]) == null ? void 0 : _a.includes(color))) {
    console.warn(`The color '${color}' is not supported with the '${variant}' variant`);
  }
}
function omitReactAriaSpecificProps(props) {
  return omit.omit(props, ["onPress", "onPressChange", "onPressStart", "onPressEnd", "onPressUp"]);
}
const UnstyledButton$1 = "_UnstyledButton_175r5_1";
const styles = {
  UnstyledButton: UnstyledButton$1
};
const UnstyledButton = React.forwardRef((props, inRef) => {
  const _a = props, { className = "", href = "", children = "Button", isDisabled = false } = _a, restProps = __objRest(_a, ["className", "href", "children", "isDisabled"]);
  const ref = React.useRef(null);
  const As = href ? "a" : "button";
  const { buttonProps: elementProps } = $701a24aa0da5b062$export$ea18c227d4417cc3(__spreadProps(__spreadValues({}, props), {
    elementType: As
  }), ref);
  return React.createElement(As, __spreadProps(__spreadValues({}, _import$1.$3ef42575df84b30b$export$9d1611c77c2fe928(omitReactAriaSpecificProps(restProps), elementProps)), {
    disabled: isDisabled,
    ref: _import$1.$5dc95899b306f630$export$c9058316764c140e(ref, inRef),
    className: utilities_css.classNames(styles.UnstyledButton, className)
  }), children);
});
UnstyledButton.displayName = "UnstyledButton";
exports.UnstyledButton = UnstyledButton;
exports.logWarningIfInvalidColorVariantCombination = logWarningIfInvalidColorVariantCombination;
